<template>
    <div v-scroll-to="sectionId" class="arrow bounce">
        <span class="fa fa-chevron-down fa-2x"></span>
    </div>
</template>        

<script>
export default {
    name: 'Arrow',
    props: [ 'sectionId' ],
    methods: {}
}
</script>

<style scoped lang="less">
span { 
    color: white; 
    cursor: pointer;
    text-decoration: none; 
}

.arrow {
    text-align: center;
}

.bounce {
    -moz-animation: bounce 4s infinite;
    -webkit-animation: bounce 4s infinite;
    animation: bounce 4s infinite;
}

@keyframes bounce {
    0%, 20%, 50%, 80%, 100% {
        transform: translateY(0);
    }
    40% {
        transform: translateY(-30px);
    }
    60% {
        transform: translateY(-15px);
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Arrow.vue